import { css, jsx } from '@emotion/react';
import Markdown from 'markdown-to-jsx';
import { labelStyles } from '@zapier/style-encapsulation';
import { Modal } from '../../display/Modal/Modal.es.js';
import { ModalContent, ModalContentHeader, ModalContentBody, ModalContentFooter } from '../../display/Modal/ModalContent.es.js';
import '../../display/Modal/ModalMediaContent.es.js';
import { Button } from '../../navigation/Button/Button.es.js';
import { baseReset } from '../../../style-mixins/reset.es.js';

const gap = "var(--zds-space-16, 15px)";
const Styles = labelStyles("PolicyModal", {
  title: css`
    ${baseReset};
  `,
  markdown: css`
    text-align: left;

    p {
      &:not(:last-child) {
        margin: 0 0 ${gap};
      }
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-bottom: ${gap};
      &:not(:first-of-type) {
        margin-top: ${gap};
      }
    }

    ul {
      ${baseReset};
      margin-left: var(--zds-space-20);
      list-style: disc;
    }
  `
});
const PolicyModal = ({ onAccept, title, tldr, url, renderMarkdown = (markdown) => jsx(Markdown, null, markdown) }) => {
  return jsx(
    Modal,
    { canClose: false, onClosed: () => {
    } },
    jsx(
      ModalContent,
      { maxWidth: "70ch" },
      jsx(
        ModalContentHeader,
        null,
        jsx(
          "h1",
          { "data-zds": true, css: Styles.title },
          "We’ve updated the ",
          title
        )
      ),
      jsx(
        ModalContentBody,
        { scrollable: true },
        jsx("div", { css: Styles.markdown, "data-zds": true }, renderMarkdown(tldr))
      ),
      jsx(
        ModalContentFooter,
        null,
        !!url && jsx(Button, { color: "secondary", href: url, target: "_blank" }, "Review changes"),
        jsx(Button, { color: "primary", hasShadow: true, onClick: onAccept }, "Accept")
      )
    )
  );
};

export { PolicyModal };
//# sourceMappingURL=PolicyModal.es.js.map
